import { doRequest } from '../../../Request';

const getUsers = (companyId: string) => {
  return doRequest({
    path: `/customers/${companyId}/users`,
  });
};

export default getUsers;
